module.exports = "/next-static/_next/static/images/hero_image_small-bb7c7ce4ba5c0b7f0e7bd71b5fba50a5.webp";